export enum AppType {
	LBM = 'LBM',
	REI = 'REI',
	LBM_FILTER = 'LBM_FILTER',
	REI_FILTER = 'REI_FILTER',
	LBM_HEATMAP = 'LBM_HEATMAP',
	REI_HEATMAP = 'REI_HEATMAP',
	FILTER = 'FILTER',
	HEATMAP = 'HEATMAP',
	GW = 'GATEWAY',
	IH = 'INSIGHTS_HUB',
	OM = 'Operations Management',
	CM = 'CONSTRUCTION_MANAGEMENT',
  GIS = 'GIS'
}
